import { Card, Pagination } from "antd";
import { ArrowUpRightIcon } from "lucide-react";
import React from "react";
import Lottie from "react-lottie";
import Utils from "../../../utils/Utils";
import Icon from "../../../assets/Icon";
import { Link, useNavigate } from "react-router-dom";
import MockGuidePageNoData from "./MockGuidePageNoData";

function MockGuideCardPage({
  notFoundFlag,
  guideData,
  pageNumber,
  pageSize,
  onPageChange,
  pageCount,
}) {
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    onPageChange(page);
  };
  console.log(guideData);
  return (
    <div>
      <>
        {!notFoundFlag ? (
          <>
            <div className="mt-4 relative flex flex-col items-center">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1rem] gap-x-[1.1rem] w-full">
                {guideData?.length > 0 &&
                  guideData.map((item, index) => (
                    <Card
                      key={index}
                      className="w-full orange-card hover-effect driverjs-alljobs-individual-guide-card"
                    >
                      <div className="min-h-[160px] flex flex-col gap-2 justify-between">
                        <div className="flex flex-col gap-1 pb-2">
                          <div className="flex flex-wrap gap-x-2 gap-y-1 justify-between break-words">
                            <div className="flex-1">
                              <p className="text-[#101828] text-[1.15rem] font-bold leading-[1.55rem]">
                                {item?.jobTitle}
                              </p>
                            </div>
                            <div className="max-w-[85px]">
                              {/* {item?.configState === "DRAFT" && (
                                <div className="border border-orange-400 bg-orange-100 text-orange-700 rounded-full px-3 text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Draft
                                  </span>
                                </div>
                              )}
                              {item?.configState === "PUBLISHED" && (
                                <div className="border border-red-400 bg-red-100 text-red-700 rounded-full px-3 w-full text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Published
                                  </span>
                                </div>
                              )} */}
                              {item?.configState === "CONFIGURED" && (
                                <div className="border border-red-400 bg-red-100 text-red-700 rounded-full px-3 w-full text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Published
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <p className="text-[#101828] font-medium text-[1.02rem]">
                            {item?.companyName}
                          </p>
                          <div className="mt-1">
                            <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                              {item?.yearsOfExperience}+ years of experience
                            </div>
                            <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                              {item?.jobLocation || "Location not specified"}
                            </div>
                          </div>
                        </div>
                        {/* <div className="my-1"></div> */}
                        <div className="">
                          <div className="">
                            <div className="mt-auto flex justify-between flex-wrap gap-x-2 items-end ">
                              <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                                {/* Created on{" "} */}
                                <strong>
                                  {Utils.converToDateMonthYear(
                                    item?.creationTime,
                                  )}
                                </strong>
                              </div>
                              <Link
                                to={`/org-admin/manage-mock-interview?jdIdentifier=${item.jdIdentifier}&iDronaId=${item.interviewConfigurationId}`}
                              >
                                <span className="flex items-center gap-2 text-amber-600 font-semibold hover:text-amber-500 text-[0.9rem] cursor-pointer driverjs-all-guide-card-action-link">
                                  {/* {item?.interviewState === "CONFIGURED" &&
                                    "Schedule interview"}
                                  {item?.interviewState ===
                                    "INTERVIEW_SCHEDULED" &&
                                    "View interveiw details"}
                                  {item?.interviewState ===
                                    "INTERVIEW_COMPLETED" && "View report"} */}
                                  Manage Interview
                                  <ArrowUpRightIcon
                                    className="hover:text-amber-500"
                                    size={20}
                                    strokeWidth={2.5}
                                    color="currentColor"
                                  />
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
              </div>

              <Pagination
                className="mt-4"
                current={pageNumber + 1}
                pageSize={pageSize}
                total={pageCount}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          </>
        ) : (
          <MockGuidePageNoData />
        )}
      </>
    </div>
  );
}

export default MockGuideCardPage;
